export default {
  bodyPart: null,

  section1: {
    question1: null,
  },

  section2: {
    question1: null,
    question2: null,
    question3: null,
    question4: null
  },

  section3: {
    question1: null,
    question2: null,
    question3: null,
    question4: null,
    question5: null,
    question6: null,
    question7: null
  },
};
